import './style.scss';

import { Checkbox as CheckboxAntd, CheckboxProps } from 'antd';

export const Checkbox = (props: CheckboxProps) => <CheckboxAntd {...props} />;

Checkbox.Group = CheckboxAntd.Group;
